import React, { useState, useEffect, useCallback } from "react";

import Form from '../../components/form/admin/solicitacoes';

function Solicitacoes({ ...props }) {

    return (
        <>
            <Form />
        </>
    );
};

export default Solicitacoes;
